import { getAuth } from "firebase/auth";
import { getAuthCentral } from "../../config/FirebaseConfig";
import { getFirestore, doc, getDoc } from "firebase/firestore";
import { checkDB } from "../../models/DataFunctions.js";
import addLogDocument from "../addLogDocument"; // Assuming you have a similar function to log actions
import { getDocDataByRef } from "../../models/DataFunctions";

const sendAvailableReportsEmail = async (folder_id, report_id,token, prefix) => {
  // Define the endpoint URL
  const url =
    prefix + "notification/available-reports-email/folders/" + folder_id +"/reports/"+report_id;

  // Retrieve users from the organization
  const db = getFirestore();

  // EMAILS TO SEND TO

  // stop here

  // Define the request body
  const body = {};

  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };

  try {
    let start = new Date();
    // Make the POST request
    const response = await fetch(url, {
      method: "POST",
      headers: headers,
      body: JSON.stringify(body), // Encode the body as JSON
    });

    const auth = getAuthCentral();
    const currentUser = auth.currentUser;
    if (!currentUser) {
      console.error("User not logged in");
      return "";
    }

    const userRef = doc(db, "user", currentUser.uid);
    const userSnapshot = await getDoc(checkDB(userRef));

    if (!userSnapshot.exists()) {
      console.error("User document not found");
      return "";
    }

    const org_id = userSnapshot.get("org_id");

    // Add log document (avoid passing full document references)
    let end = new Date();
    let elapsed = end - start;
    await addLogDocument(
      url,
      prefix,
      userRef, // Only log the userRef ID
      org_id,
      response.status.toString(),
      "", // folderid
      "", // docid
      JSON.stringify(body), // request body as string
      await response.text(),
      "POST",
      elapsed
    );

    // Check if the request was successful
    if (response.ok) {
      return { success: true };
    } else {
      console.error(`Failed to send email: ${response.status}`);
      return { success: false, error: `Failed to send email: ${response.status}` };
    }
  } catch (error) {
    console.error(`Exception occurred: ${error.message}`);
    return { success: false, error: `Exception occurred: ${error.message}` };
  }
};

export default sendAvailableReportsEmail;
